import { Card, Col, Row, Divider, Typography, Tooltip, Button } from "antd";
import { FaCheck, FaTimes, FaCog } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { APP_URLS } from "@neonumy/api-clients";
import CardTitle from "components/CardTitle";
import useCoreStore from "views/hooks/useCoreStore";
import { FaArrowRightToBracket } from "react-icons/fa6";

const { Text } = Typography;

export default function ExportCard({
  platformData,
}: {
  platformData: PlatformData | undefined;
}): React.ReactElement {
  const { t } = useTranslation();
  const companySelected = useCoreStore(state => state.companySelected);
  return (
    <Card
      title={<CardTitle icon={<FaCog />} title={t("Export configuration")} />}
      className="antd-newrai-card invoice-info-cards"
      // extra={<ExportFormModal refetch={refetch} />}
      extra={
        <Tooltip title={t("Go to company settings")} placement="left">
          <Button
            className="archive-btn"
            type="primary"
            icon={<FaArrowRightToBracket />}
            size="small"
            onClick={() => {
              window.open(
                `${APP_URLS.dashboardUrl}companies/${companySelected?.id}/settings`,
                "_blank",
              );
            }}
          />
        </Tooltip>
      }
    >
      <Row>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("Do export")}</span>
          <span>
            {platformData?.canExport ? <FaCheck color="green" /> : <FaTimes color="red" />}
          </span>
        </Col>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("Software")}</span>
          <span>{platformData?.software?.name || ""}</span>
        </Col>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("Prefix client counterpart code")}</span>
          <span>
            {platformData?.prefixClientAccount ||
              platformData?.software?.defaultPrefixClientAccount ||
              ""}
          </span>
        </Col>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("Prefix provider counterpart code")}</span>
          <span>
            {platformData?.prefixProviderAccount ||
              platformData?.software?.defaultPrefixProviderAccount ||
              ""}
          </span>
        </Col>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("Default clients counterparts")}</span>
          <span>
            {platformData?.collectiveClientAccount ||
              platformData?.software?.collectiveClientAccount ||
              ""}
          </span>
        </Col>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("Default providers counterparts")}</span>
          <span>
            {platformData?.collectiveProviderAccount ||
              platformData?.software?.collectiveProviderAccount ||
              ""}
          </span>
        </Col>
        <Divider style={{ margin: "8px 0" }} />
        <Col span={24}>
          <Text style={{ fontSize: "16px" }}>{t("Length of counterparts")}</Text>
        </Col>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("General accounts length")}</span>
          <span>{platformData?.generalAccountsLength || "8"}</span>
        </Col>
        <Col className="info-col" span={12}>
          <span className="info-col-label">{t("Third parties accounts length")}</span>
          <span>{platformData?.thirdPartiesAccountsLength || "8"}</span>
        </Col>
      </Row>
    </Card>
  );
}
